/* Sale Muebles: filtro propio y server-first. */
(function () {
  'use strict';

  var VOCAB = ['bares-de-terraza', 'livings', 'bancas'];
  var LABELS = {
    'bares-de-terraza': 'Bares de terraza',
    livings: 'Livings',
    bancas: 'Bancas'
  };

  function init() {
    var root = document.querySelector('[data-sale-plp-root][data-sale-collection-handle="sale-muebles"][data-ch-filter-count-owner="sale-muebles"]');
    if (!root) return;

    var dataNode = document.getElementById('ch-smu-data');
    var drawer = root.querySelector('[data-ch-sale-muebles-drawer]');
    var panel = drawer && drawer.querySelector('.ch-smu__panel');
    if (!dataNode || !drawer || !panel) return;

    document.body.classList.add('ch-sale-muebles-filter');

    var products = [];
    try { products = JSON.parse(dataNode.textContent || '[]'); } catch (error) { products = []; }

    var collectionUrl = (root.getAttribute('data-sale-collection-url') || '/collections/sale-muebles').replace(/\/+$/, '');
    var defaultSort = drawer.getAttribute('data-ch-sale-muebles-default-sort') || 'manual';
    var selectedTag = tagFromPath(window.location.pathname);
    var appliedTag = selectedTag;
    var selectedSort = new URLSearchParams(window.location.search).get('sort_by') || defaultSort;
    var appliedSort = selectedSort;
    var activePage = root.querySelector('[data-ch-sale-muebles-active-page]');
    var applyButton = drawer.querySelector('[data-ch-sale-muebles-apply]');
    var totalNode = drawer.querySelector('[data-ch-sale-muebles-total]');
    var lastOpener = null;
    var requestId = 0;
    var inertRecords = [];

    // --- Contrato transversal compartido por los cinco filtros propios
    //     (assets/chagual-filter-contract.js). Resolucion perezosa y tolerante:
    //     si esa capa no cargo, el filtro sigue operando igual que antes. ---
    function shared(name) {
      var api = window.ChagualFilterContract;
      var fn = api && api[name];
      return typeof fn === 'function' ? fn : function () {};
    }

    function appliedFacets() {
      var facets = [];
      if (appliedTag) facets.push({ facet: 'tipo', value: appliedTag });
      if (appliedSort && appliedSort !== defaultSort) facets.push({ facet: 'orden', value: appliedSort });
      return facets;
    }

    function openers() {
      return Array.prototype.slice.call(document.querySelectorAll('[data-ch-sale-muebles-filter-open],[data-ch-sale-muebles-sort-open]'));
    }

    function syncOpeners(active) {
      openers().forEach(function (opener) {
        opener.setAttribute('aria-controls', drawer.id);
        opener.setAttribute('aria-expanded', active && opener === lastOpener ? 'true' : 'false');
      });
    }

    function tagFromPath(pathname) {
      var parts = String(pathname || '').split('/').filter(Boolean);
      var collectionIndex = parts.indexOf('collections');
      var tail = collectionIndex >= 0 && parts.length > collectionIndex + 2 ? parts[collectionIndex + 2] : '';
      if (!tail) return '';
      var tags;
      try { tags = decodeURIComponent(tail).toLowerCase().split('+'); } catch (error) { tags = tail.toLowerCase().split('+'); }
      for (var i = 0; i < VOCAB.length; i += 1) {
        if (tags.indexOf(VOCAB[i]) !== -1) return VOCAB[i];
      }
      return '';
    }

    function countFor(tag) {
      if (!tag) return products.length;
      return products.reduce(function (total, product) {
        return total + ((product.t || []).indexOf(tag) !== -1 ? 1 : 0);
      }, 0);
    }

    function renderDrawer() {
      Array.prototype.forEach.call(drawer.querySelectorAll('[data-ch-sale-muebles-filter]'), function (button) {
        var tag = button.getAttribute('data-tag');
        var selected = selectedTag === tag;
        var count = countFor(tag);
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-checked', selected ? 'true' : 'false');
        button.setAttribute('aria-disabled', count === 0 && !selected ? 'true' : 'false');
        var countElement = button.querySelector('[data-ch-sale-muebles-count]');
        if (countElement) countElement.textContent = String(count);
      });
      Array.prototype.forEach.call(drawer.querySelectorAll('[data-ch-sale-muebles-sort]'), function (button) {
        var selected = button.getAttribute('data-ch-sale-muebles-sort') === selectedSort;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-checked', selected ? 'true' : 'false');
      });
      if (totalNode) totalNode.textContent = String(countFor(selectedTag));
      // B9: una sola parada de tabulacion por grupo de botones de opcion.
      shared('refreshRoving')(drawer);
    }

    function renderActivePage() {
      if (!activePage) return;
      if (!appliedTag) {
        activePage.hidden = true;
        activePage.innerHTML = '';
        return;
      }
      activePage.hidden = false;
      activePage.innerHTML = '<button type="button" class="ch-smu-active-page__chip" data-ch-sale-muebles-remove>' +
        '<span>' + LABELS[appliedTag] + '</span><span aria-hidden="true">&times;</span>' +
        '<span class="ch-smu__sr">Quitar filtro ' + LABELS[appliedTag] + '</span></button>';
    }

    function buildUrl(tag, sort, page) {
      var url = tag ? collectionUrl + '/' + tag : collectionUrl;
      var params = new URLSearchParams();
      if (sort && sort !== defaultSort) params.set('sort_by', sort);
      if (page && page > 1) params.set('page', String(page));
      var query = params.toString();
      return query ? url + '?' + query : url;
    }

    function resultsNode(scope) {
      if (scope && scope.matches && scope.matches('[data-ch-filter-results][data-ch-filter-owner="sale-muebles"]')) return scope;
      return (scope || document).querySelector('[data-ch-filter-results][data-ch-filter-owner="sale-muebles"]');
    }

    function resultsTotal(scope) {
      var results = resultsNode(scope);
      if (!results) return null;
      var total = parseInt(results.getAttribute('data-ch-filter-total'), 10);
      return isNaN(total) || total < 0 ? null : total;
    }

    function setGridCount(total) {
      var count = root.querySelector('[data-sale-grid-count]');
      if (!count) return;
      count.setAttribute('data-ch-filter-count-current', String(total));
      count.textContent = total === 1 ? '1 producto' : total + ' productos';
    }

    function emitCatalogUpdated(total, url) {
      document.dispatchEvent(new CustomEvent('chagual:catalog-updated', {
        detail: { owner: 'sale-muebles', total: total, url: url }
      }));
    }

    // --- Cambio de pagina accesible (hallazgo P1 numero 3 de la auditoria 16).
    //     Antes el swap reemplazaba el resultado y dejaba al cliente donde estaba,
    //     con el foco perdido y sin aviso. Ahora: anuncio en la region viva que
    //     sobrevive al swap, foco al inicio del resultado y vista controlada. ---
    function announceResults(page, pages, total) {
      var status = root.querySelector('[data-ch-filter-status]');
      if (!status) return;
      var message = total === 1 ? '1 producto' : total + ' productos';
      if (pages > 1 && page > 0) message = 'Página ' + page + ' de ' + pages + '. ' + message;
      status.textContent = message + '.';
    }

    function headerOffset() {
      if (typeof window.getComputedStyle !== 'function' || !document.documentElement) return 0;
      var raw = window.getComputedStyle(document.documentElement).getPropertyValue('--chagual-header-offset');
      var value = parseFloat(raw);
      return isFinite(value) && value > 0 ? value : 0;
    }

    function focusResultsStart(node) {
      if (!node) return;
      try { node.focus({ preventScroll: true }); } catch (error) { node.focus(); }
      if (typeof node.getBoundingClientRect !== 'function' || typeof window.scrollTo !== 'function') return;
      var top = node.getBoundingClientRect().top + (window.pageYOffset || 0) - headerOffset() - 8;
      window.scrollTo(0, top > 0 ? top : 0);
    }

    // `action` describe que hizo la persona: alimenta la medicion compartida
    // (auditoria 24, huecos 1, 2, 3 y 5) sin cambiar el flujo del swap. Sin
    // `action` explicito es restauracion de historial y no se mide.
    function swapResults(url, pushHistory, returnFocus, action) {
      var intent = action || 'history';
      var live = resultsNode(root);
      if (!live || typeof fetch !== 'function') {
        shared('trackFallback')('sale-muebles', 'sin-fetch', url);
        window.location.assign(url);
        return;
      }
      var currentRequest = ++requestId;
      shared('beginBusy')(root);
      fetch(url, { headers: { 'X-Requested-With': 'fetch' }, credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Respuesta invalida');
          return response.text();
        })
        .then(function (html) {
          if (currentRequest !== requestId) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshRoot = doc.querySelector('[data-sale-plp-root][data-sale-collection-handle="sale-muebles"][data-ch-filter-count-owner="sale-muebles"]');
          var fresh = freshRoot && resultsNode(freshRoot);
          live = resultsNode(root);
          var total = resultsTotal(fresh);
          var freshPage = fresh ? parseInt(fresh.getAttribute('data-ch-filter-page'), 10) : NaN;
          var expectedInfeedCount = freshPage === 1 && total > 0 ? 1 : 0;
          var infeedCount = fresh ? fresh.querySelectorAll('[data-sale-infeed-shell]').length : 0;
          if (!fresh || !live || total == null || isNaN(freshPage) || infeedCount !== expectedInfeedCount) { shared('trackFallback')('sale-muebles', 'respuesta-incompleta', url); window.location.assign(url); return; }
          if (!window.ChagualCollectionSeoSync || !window.ChagualCollectionSeoSync.apply(doc)) { shared('trackFallback')('sale-muebles', 'sin-seo-sync', url); window.location.assign(url); return; }
          var previousPage = parseInt(live.getAttribute('data-ch-filter-page'), 10);
          var freshPages = parseInt(fresh.getAttribute('data-ch-filter-pages'), 10);
          live.replaceWith(fresh);
          if (pushHistory !== false && window.history && window.history.pushState) {
            window.history.pushState({ chagualCatalog: 'sale-muebles' }, '', url);
          }
          setGridCount(total);
          closeDrawer(returnFocus === true);
          announceResults(freshPage, freshPages, total);
          if (!isNaN(freshPage) && !isNaN(previousPage) && freshPage !== previousPage) focusResultsStart(fresh);
          emitCatalogUpdated(total, url);
          // Medicion compartida: faceta, valor y cantidad de resultados.
          if (intent === 'clear') shared('trackClear')('sale-muebles', total, url, 'drawer');
          else if (intent === 'apply') shared('trackApply')('sale-muebles', appliedFacets(), total, url);
        })
        .catch(function () {
          if (currentRequest === requestId) {
            shared('trackFallback')('sale-muebles', 'peticion-fallida', url);
            window.location.assign(url);
          }
        })
        // B10: solo la respuesta vigente puede dar por terminada la carga. Sin
        // esta guarda una peticion vieja retiraba el estado ocupado que habia
        // puesto la nueva. El modelo es chagual-sale-root-filter.js.
        .then(function () { shared('endBusy')(root, currentRequest === requestId); });
    }

    function markInert(element) {
      if (!element || element.nodeType !== 1) return;
      var record = { element: element, inert: false, aria: false };
      if (!element.hasAttribute('inert')) { element.setAttribute('inert', ''); record.inert = true; }
      if (!element.hasAttribute('aria-hidden')) { element.setAttribute('aria-hidden', 'true'); record.aria = true; }
      if (record.inert || record.aria) inertRecords.push(record);
    }

    function setBackgroundInert(on) {
      if (on) {
        var node = drawer;
        while (node && node.parentNode && node !== document.body) {
          Array.prototype.forEach.call(node.parentNode.children, function (sibling) { if (sibling !== node) markInert(sibling); });
          node = node.parentNode;
        }
      } else {
        inertRecords.forEach(function (record) {
          if (record.inert) record.element.removeAttribute('inert');
          if (record.aria) record.element.removeAttribute('aria-hidden');
        });
        inertRecords = [];
      }
    }

    function focusables() {
      return Array.prototype.slice.call(panel.querySelectorAll('button:not([disabled]):not([aria-disabled="true"]),a[href],[tabindex]:not([tabindex="-1"])'))
        .filter(function (element) { return element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement; });
    }

    function openDrawer(opener, group) {
      lastOpener = opener || lastOpener;
      drawer.hidden = false;
      drawer.removeAttribute('inert');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add('is-open');
      document.body.classList.add('ch-smu-lock');
      setBackgroundInert(true);
      syncOpeners(true);
      renderDrawer();
      var target = drawer.querySelector('[data-ch-sale-muebles-group="' + (group || 'tipo') + '"]');
      var first = target && target.querySelector('[role="radio"]');
      try { (first || panel).focus({ preventScroll: true }); } catch (error) { (first || panel).focus(); }
      if (target) target.scrollIntoView({ block: 'start' });
    }

    function closeDrawer(returnFocus) {
      var wasOpen = drawer.classList.contains('is-open');
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.hidden = true;
      drawer.setAttribute('inert', '');
      document.body.classList.remove('ch-smu-lock');
      setBackgroundInert(false);
      syncOpeners(false);
      if (returnFocus !== false && wasOpen && lastOpener && typeof lastOpener.focus === 'function') lastOpener.focus();
    }

    document.addEventListener('click', function (event) {
      var filterOpen = event.target.closest && event.target.closest('[data-ch-sale-muebles-filter-open]');
      var sortOpen = event.target.closest && event.target.closest('[data-ch-sale-muebles-sort-open]');
      if (filterOpen || sortOpen) {
        event.preventDefault();
        openDrawer(filterOpen || sortOpen, sortOpen ? 'orden' : 'tipo');
        return;
      }
      var remove = event.target.closest && event.target.closest('[data-ch-sale-muebles-remove]');
      if (remove) {
        event.preventDefault();
        selectedTag = appliedTag = '';
        renderDrawer();
        renderActivePage();
        // B12: el chip pulsado desaparece; el foco pasa al chip siguiente y, si
        // no queda ninguno, al boton que abre el cajon. Patron copiado de
        // chagual-maceteros-filter.js a traves del contrato compartido.
        shared('focusAfterChipRemoval')(activePage, '[data-ch-sale-muebles-remove]', document.querySelector('[data-ch-sale-muebles-filter-open]'));
        swapResults(buildUrl('', appliedSort), true, false, 'clear');
        return;
      }
      var pageLink = event.target.closest && event.target.closest('[data-ch-filter-results][data-ch-filter-owner="sale-muebles"] .ch-smu-pagination a');
      if (pageLink) {
        event.preventDefault();
        swapResults(pageLink.href);
      }
    });

    drawer.addEventListener('click', function (event) {
      if (event.target.closest('[data-ch-sale-muebles-close]')) { event.preventDefault(); closeDrawer(true); return; }
      var filter = event.target.closest('[data-ch-sale-muebles-filter]');
      if (filter) {
        event.preventDefault();
        if (filter.getAttribute('aria-disabled') === 'true') return;
        var tag = filter.getAttribute('data-tag');
        selectedTag = selectedTag === tag ? '' : tag;
        renderDrawer();
        return;
      }
      var sort = event.target.closest('[data-ch-sale-muebles-sort]');
      if (sort) {
        event.preventDefault();
        selectedSort = sort.getAttribute('data-ch-sale-muebles-sort') || defaultSort;
        renderDrawer();
      }
    });

    drawer.addEventListener('keydown', function (event) {
      if (event.key === 'Tab' && drawer.classList.contains('is-open')) {
        var items = focusables();
        if (!items.length) { event.preventDefault(); panel.focus(); return; }
        var first = items[0], last = items[items.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });

    // B9: el movimiento dentro de los grupos de botones de opcion pasa a la capa
    // compartida, que agrega Inicio y Fin y deja una sola parada de tabulacion
    // por grupo. Este owner solo aporta su vocabulario de teclas y su estado.
    shared('bindRadioKeyboard')(drawer, function (next) {
      var filterTag = next.getAttribute('data-tag');
      if (filterTag) selectedTag = filterTag;
      var sortValue = next.getAttribute('data-ch-sale-muebles-sort');
      if (sortValue) selectedSort = sortValue;
      renderDrawer();
    }, ['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft']);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(true);
    });

    var clear = drawer.querySelector('[data-ch-sale-muebles-clear]');
    if (clear) clear.addEventListener('click', function (event) {
      event.preventDefault();
      selectedTag = appliedTag = '';
      selectedSort = appliedSort = defaultSort;
      renderDrawer();
      renderActivePage();
      swapResults(buildUrl('', defaultSort), true, true, 'clear');
    });

    if (applyButton) applyButton.addEventListener('click', function (event) {
      event.preventDefault();
      appliedTag = selectedTag;
      appliedSort = selectedSort;
      renderActivePage();
      swapResults(buildUrl(appliedTag, appliedSort), true, true, 'apply');
    });

    window.addEventListener('popstate', function () {
      selectedTag = appliedTag = tagFromPath(window.location.pathname);
      selectedSort = appliedSort = new URLSearchParams(window.location.search).get('sort_by') || defaultSort;
      renderDrawer();
      renderActivePage();
      swapResults(window.location.href, false);
    });

    renderDrawer();
    renderActivePage();
    syncOpeners(false);
    var initialTotal = resultsTotal(root);
    if (initialTotal != null) setGridCount(initialTotal);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
